import { Component, ElementRef, HostListener, Inject, OnInit, ViewChild } from '@angular/core';
import { NgForOf, NgIf } from "@angular/common";
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { KonvasComponent } from "../../component/konvas/konvas.component";
import { Subscription } from "rxjs";
import { ConfigService } from "../../common/service/config.service";

@Component({
  selector: 'app-config',
  standalone: true,
  imports: [
    NgForOf,
    ReactiveFormsModule,
    KonvasComponent,
    NgIf
  ],
  templateUrl: './config.component.html'
})
export class ConfigComponent implements OnInit {

  @ViewChild('videoContainer') videoContainer!: ElementRef;
  public videoAllowed = true;
  public config: any;

  public form!: FormGroup;
  public formReady = false;
  protected devices: MediaDeviceInfo[] | undefined;
  public rotate: number = 0;

  protected subscription: Subscription | undefined;
  loading: boolean = true;

  constructor(
    @Inject('Storage') protected storage: Storage,
    protected router: Router,
    protected route: ActivatedRoute,
    protected configService: ConfigService
  ) {}

  ngOnInit(): void {
    this.subscription = this.configService.config$.subscribe((config) => {
      this.config = config;
    });

    navigator.mediaDevices.enumerateDevices()
      .then((devices: MediaDeviceInfo[]) => {
        this.devices = devices.filter((device: MediaDeviceInfo) => device.kind === 'videoinput');
        setTimeout(() => {
          this.startVideo();
          this.loading = false;
        }, 1000);
      })
      .catch(console.error);

    const selectedCamera = localStorage.getItem('camera');
    const selectedForceBoothMode: string | null = localStorage.getItem('forceBoothMode');
    const rotation: string | null = localStorage.getItem('rotation');

    this.form = new FormGroup({
      'device': new FormControl(selectedCamera, [Validators.required]),
      'forceBoothMode': new FormControl(selectedForceBoothMode === 'true'),
      'rotation': new FormControl(rotation || 0)
    });
  }

  onSubmit() {

    console.log('submit', this.form.valid, this.form.value);

    this.storage.setItem('camera', this.form.value.device);
    this.storage.setItem('forceBoothMode', this.form.value.forceBoothMode);
    this.storage.setItem('rotation', this.form.value.rotation);

    this.router.navigate(['..', 'home' ], { relativeTo: this.route }).then();
  }

  @HostListener('change', [ '$event' ])
  onChange(event: any) {
    // console.log('change', event.target.value);
    if(event.target.value && ! ['0', '90', '180', '270'].includes(event.target.value)) {
      // console.log(event.target.value);
      this.formReady = true;
    }
  }

  protected startVideo(deviceId?: string) {

    if(this.videoContainer) {

      console.log('startVideo', this.videoContainer);

      const vc = this.videoContainer.nativeElement as HTMLVideoElement;
      vc.onloadedmetadata = () => {
        console.log('onloadedmetadata');
        vc.play().then(console.log).catch(console.error);
      };

      const candidate = this.storage.getItem('camera');
      if( ! deviceId && candidate) {
        deviceId = candidate;
      }

      // console.log('startvideo with device id', deviceId);

      navigator.mediaDevices.getUserMedia({
        video: {
          width: 720,
          aspectRatio: 1, //this.config.aspectRatio,
          deviceId: deviceId ? { exact: deviceId } : undefined,
          frameRate: 30,
          facingMode: 'user'
        }, audio: false
      }).then((stream: MediaStream) => {
        console.log('then ', stream);
        vc.playsInline = true;
        vc.autoplay = true;
        vc.muted = true;
        vc.srcObject = stream;
      }).catch((error) => {
          console.log('catch ', error);
          console.log('startVideo', error);
          if (error.name == 'NotAllowedError') {
            this.videoAllowed = false;
          }
        });
    }
  }

  switchCamera($event: Event) {
    console.log('switchCamera', ($event.target as HTMLSelectElement).value);
    this.startVideo(($event.target as HTMLSelectElement).value);
  }

  setRotation($event: Event) {
    console.log('setRotation', ($event.target as HTMLSelectElement).value);
    this.rotate = parseInt(($event.target as HTMLSelectElement).value);
  }
}
